import * as React from "react";
import { s3baseUrl } from "src/config/config";
import GrPhotoGrid from "src/design-system/components/GrPhotoGrid";

// A post's photos as one GrPhotoGrid. Opening a photo calls handleClickImage(event, index, url),
// the same arguments the older gallery passed.
export default function FeedImagesList({ feed_images, handleClickImage, sx }) {
  const photos = Array.isArray(feed_images)
    ? feed_images.map((image) => s3baseUrl + image?.thumbnail_2)
    : [];

  return (
    <GrPhotoGrid
      photos={photos}
      onOpen={(index, event) => handleClickImage(event, index, photos[index])}
      sx={sx}
    />
  );
}
